/**
 * Base Map Create Page
 * 
 * Page for creating a new base map.
 */

import React from 'react';
import { Container, SpaceBetween, Header } from '@cloudscape-design/components';
import BaseMapForm from '../../components/admin/BaseMapForm';

const BaseMapCreate: React.FC = () => {
  return (
    <SpaceBetween size="l">
      <Header
        variant="h1"
        description="Create a new base map for the Print Map Maker"
      >
        Create Base Map
      </Header>

      <Container>
        <BaseMapForm mode="create" />
      </Container>
    </SpaceBetween>
  );
};

export default BaseMapCreate;
